var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { background: "transparent", border: "none" } },
    [
      _c(
        "w-card-title",
        {
          style: {
            padding: "0px 15px",
            borderBottom: "none",
            fontWeight: "bold",
            fontSize: "14px",
          },
        },
        [_vm._t("title")],
        2
      ),
      _c(
        "w-card-content",
        {
          style: { overflow: "hidden", paddingTop: "5px" },
          attrs: { "no-padding": "" },
        },
        [
          _c(
            "w-list",
            _vm._l(_vm.channels, function (channel, i) {
              return _c(
                "w-list-item",
                { key: i, attrs: { to: "/chat/channel/" + channel.ID } },
                [
                  channel.Unread > 0
                    ? _c("span", { staticClass: "unread" }, [
                        _vm._v(_vm._s(channel.Unread)),
                      ])
                    : _vm._e(),
                  _c("w-fa", { attrs: { icon: "hashtag" } }),
                  _vm._v(" " + _vm._s(channel.Name) + " "),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }